import {
  Icon,
  ReadingPreferences,
  Sheet,
  applyPreferences,
  loadPreferences,
  savePreferences,
  type Preferences,
} from "@tutor/ui";
import { useState } from "react";
import { useT } from "../i18n";

// Reading and display preferences for this device: theme, dyslexia-friendly letters,
// text size, motion and contrast (ADR-0031). Display settings only, no personal data;
// they stay in this browser's storage.

function storage(): Storage | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

/** Applies the saved preferences before the first paint, so the page never flashes. */
export function applySavedPreferences(): void {
  applyPreferences(loadPreferences(storage()), document.documentElement);
}

export function DisplaySettings() {
  const t = useT();
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState<Preferences>(() => loadPreferences(storage()));
  const change = (next: Preferences) => {
    setPrefs(next);
    applyPreferences(next, document.documentElement);
    savePreferences(storage(), next);
  };
  return (
    <>
      <button
        type="button"
        className="ui-icon-button display-settings"
        aria-label={t("settings.display")}
        aria-haspopup="dialog"
        onClick={() => {
          setOpen(true);
        }}
      >
        <Icon name="settings" />
      </button>
      <Sheet
        open={open}
        title={t("settings.display")}
        onClose={() => {
          setOpen(false);
        }}
      >
        <ReadingPreferences value={prefs} onChange={change} />
      </Sheet>
    </>
  );
}
